import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ items }) => {
    return (
        <ol className="mt-2 flex items-center whitespace-nowrap">
            {items.map((item, index) => (
                <li key={index} className="inline-flex items-center">
                    {index < items.length - 1 ? (
                        <>
                            <Link
                                className="flex items-center text-xs sm:text-sm text-gray-500 hover:text-blue-600 focus:outline-none focus:text-blue-600 dark:text-neutral-500 dark:hover:text-blue-500 dark:focus:text-blue-500"
                                to={item.to}
                            >
                                {item.label}
                            </Link>
                            <svg
                                className="shrink-0 size-5 text-gray-400 dark:text-neutral-600 mx-0"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path d="M6 13L10 3" stroke="currentColor" strokeLinecap="round"></path>
                            </svg>
                        </>
                    ) : (
                        <span
                            className="inline-flex items-center text-xs sm:text-sm font-semibold text-gray-800 truncate dark:text-neutral-200"
                            aria-current="page"
                        >
                            {item.label}
                        </span>
                    )}
                </li>
            ))}
        </ol>
    );
};

Breadcrumbs.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            href: PropTypes.string,
        })
    ).isRequired,
};

export default Breadcrumbs;

